import { createSelector } from "reselect"
import { chain, get, isEmpty } from "lodash"
import { getCategories } from "selectors/factors"
import { getCurrentPerformance } from "./performance"
import { getDisplayCategories } from "./data"
import { getDisplayType } from "./items"
import { computeSelectedOption } from "helpers/analyze"

export const getOptions = createSelector(
  [getCurrentPerformance, getCategories, getDisplayCategories],
  (current, categories, displayCategories) => {
    if (current) {
      const options = [{
        id: "total",
        color: "#00abe8",
        label: "Total",
        value: current.total,
      },
      ...[!isEmpty(current.factors) && {
        id: "factors",
        color: "#9067a7",
        label: "Factors",
        value: current.factorsTotal,
      }],
      ...categories
        .filter(category => !category.singleFactor)
        .map(category => {
          if (displayCategories.indexOf(category.id) === -1) return null

          const field = `categories.${category.id}`
          const value = get(current, field)

          return { value, ...category }
        }),
      ]

      // filter out options for which there's no value
      return chain(options)
        .compact()
        .filter(option => !Number.isNaN(option.value))
        .value()
    } else {
      return []
    }
  },
)

export const getSelectedOption = createSelector(
  [getOptions, getDisplayType],
  computeSelectedOption,
)
